import { HttpMethod, initFetch } from "../../utils/fetcher";
import {
  adaptedToRecherche,
  recherchesToAdapted,
  rechercheToAdapted,
} from "../../adapter/rechercheAdapter";

export const LOAD_SUCCESS_RECHERCHES = "LOAD_SUCCESS_RECHERCHES";
export const LOAD_FAIL_RECHERCHES = "LOAD_FAIL_RECHERCHES";
export const SAVE_SUCCESS_RECHERCHES = "SAVE_SUCCESS_RECHERCHES";
export const SAVE_FAIL_RECHERCHES = "SAVE_FAIL_RECHERCHES";
export const UPDATE_SUCCESS_RECHERCHES = "UPDATE_SUCCESS_RECHERCHES";
export const UPDATE_FAIL_RECHERCHES = "UPDATE_FAIL_RECHERCHES";
export const DELETE_SUCCESS_RECHERCHES = "DELETE_SUCCESS_RECHERCHES";
export const DELETE_FAIL_RECHERCHES = "DELETE_FAIL_RECHERCHES";

export const SAVE_SUCCESS_REQUETE_RECHERCHE = "SAVE_SUCCESS_REQUETE_RECHERCHE";

export const SAVE_SUCCESS_RENDUA_RECHERCHE = "SAVE_SUCCESS_RENDUA_RECHERCHE";

export function loadRecherches() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch("recherches", HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.recherche);
          dispatch({
            type: LOAD_SUCCESS_RECHERCHES,
            payload: recherchesToAdapted(res.recherche),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_RECHERCHES,
            error: err,
          });
        });
    });
  };
}

export function saveRecherche(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch("recherches", HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToRecherche(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(rechercheToAdapted(res.recherche));
          dispatch({
            type: SAVE_SUCCESS_REQUETE_RECHERCHE,
            payload: rechercheToAdapted(res.recherche),
          });
          dispatch({
            type: SAVE_SUCCESS_RENDUA_RECHERCHE,
            payload: rechercheToAdapted(res.recherche),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_RECHERCHES,
            error: err,
          })
        );
    });
  };
}

export function updateRecherche(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`recherches/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToRecherche(jsonData)) })
        // make async call to database
        .then((res) => res.json())
        .then((res) => {
          resolve(rechercheToAdapted(res.recherche));
          dispatch({
            type: UPDATE_SUCCESS_RECHERCHES,
            payload: rechercheToAdapted(res.recherche),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_RECHERCHES,
            error: err,
          })
        );
    });
  };
}

export function deleteRecherche(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`recherches/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.recherche);
          dispatch({
            type: DELETE_SUCCESS_RECHERCHES,
            payload: rechercheToAdapted(res.recherche),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_RECHERCHES,
            error: err,
          });
        });
    });
  };
}
